import { Col, Divider, Form, Input, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import CustomDatePicker from '../../components/CustomDatePicker';
import MetodoPago from '../../components/MetodoPago';
import EmpresaContext from '../../context/empresa-context';
import UserContext from '../../context/user-context';
import AseguradoCartaVerdeForm from './AseguradoCartaVerdeForm';
import LaboralesCartaVerdeForm from './LaboralesCartaVerdeForm';
import VehiculoCartaVerdeForm from './VehiculoCartaVerdeForm';

const SolicitudCartaVerdeForm = ({
  data,
  updateData,
  empresaProductoMetodo,
  forms
}) => {
  const { empresa } = useContext(EmpresaContext);
  const { user } = useContext(UserContext);

  const [metodoPagoFilterList, setMetodoPagoFilterList] = useState();
  const {
    formVehiculo,
    formAsegurado,
    formLaborales,
    formPeriodo,
    formMetodo
  } = forms;

  useEffect(() => {
    if (data.fields?.metodoPago) {
      formMetodo.setFieldsValue({
        metodoPago: data.fields?.metodoPago,
        metodoPagoDescripcion: data.fields?.metodoPago?.descripcion || ''
      });
    }
  }, [formMetodo, data.fields?.metodoPago]);

  useEffect(() => {
    // si la cotizacion fue modificada y si no tiene usuario logueado solo puede seleccionar caja/ventanilla.
    const listFilter = empresaProductoMetodo
      .filter(({ metodoPago }) => {
        // Si el usuario es admin, no se aplica filtro
        if (user && user['cognito:groups']?.[0] === 'ADMIN') {
          return true;
        }
        // Si no es admin, se filtra por el ID del método de pago
        return metodoPago.id === data.fields?.metodoPago;
      })
      .map(({ metodoPago }) => metodoPago);

    setMetodoPagoFilterList(listFilter);
  }, [empresaProductoMetodo, data.fields?.metodoPago, user]);

  return (
    <>
      <Divider>Datos del vehículo</Divider>
      <br />
      {data.fields && (
        <VehiculoCartaVerdeForm
          form={formVehiculo}
          data={data.fields}
          updateData={(newData) =>
            updateData('fields', { ...data.fields, ...newData })
          }
        />
      )}

      {/* Incluye formulario de Asegurado y Facturacion */}
      {data.fields && (
        <AseguradoCartaVerdeForm
          form={formAsegurado}
          data={data.fields}
          updateData={(newData) =>
            updateData('fields', { ...data.fields, ...newData })
          }
        />
      )}

      <Divider>Confirme sus Datos Laborales</Divider>
      <br />
      {empresa.seprelad && (
        <LaboralesCartaVerdeForm
          form={formLaborales}
          data={data.fields}
          updateData={(newData) =>
            updateData('fields', { ...data.fields, ...newData })
          }
        />
      )}

      <Divider>Confirme sus datos de Vigencia y Pagos</Divider>
      <br />
      {data.fields && (
        <Form
          name="periodo"
          form={formPeriodo}
          initialValues={data.fields.vigencia}
          scrollToFirstError
          layout="vertical"
        >
          <Row
            gutter={[16, 0]}
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'start'
            }}
          >
            <Col xs={24} md={12}>
              <Form.Item
                label="Desde"
                name="desde"
                rules={[{ required: true }]}
              >
                <CustomDatePicker
                  style={{ width: '100%' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Hasta"
                name="hasta"
                rules={[{ required: true }]}
                disabled
              >
                <CustomDatePicker
                  style={{ width: '100%' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Cantidad de días"
                name="cantidad_dias"
                rules={[{ required: true }]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}

      <Divider>Opciones de pago</Divider>
      <br />
      {data.fields && metodoPagoFilterList && (
        <Form
          name="metodo"
          form={formMetodo}
          initialValues={data.fields.metodoPago}
          scrollToFirstError
          layout="vertical"
        >
          <Row
            gutter={[16, 0]}
            style={{
              marginTop: 'auto',
              marginBottom: 'auto',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'start'
            }}
          >
            <Col xs={24} md={12}>
              <Form.Item
                label="Medio de pago"
                name="metodoPago"
                rules={[{ required: true }]}
              >
                <MetodoPago
                  handleFormChange={(e) => {
                    const selectedMetodo = empresaProductoMetodo.find(
                      (item) => item.id_metodo_pago === e
                    );
                    updateData('fields', {
                      ...data.fields,
                      metodoPago: e,
                      metodoPagoDescripcion:
                        selectedMetodo?.metodoPago?.descripcion || ''
                    });
                    formMetodo.setFieldsValue({
                      metodoPago: e,
                      metodoPagoDescripcion:
                        selectedMetodo?.metodoPago?.descripcion || ''
                    });
                  }}
                  form={formMetodo}
                  metodoPago={data.fields?.metodoPago}
                  listaMetodoPago={metodoPagoFilterList}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};

export default SolicitudCartaVerdeForm;
